import type { ReactNode } from 'react'
import { useUsuarioActual, esAdmin } from '../hooks/useUsuarioActual'
import { Cargando } from './Cargando'
import { EstadoVacio } from './EstadoVacio'

/**
 * Pantallas solo de administrador (Usuarios, Ajustes). El backend ya responde
 * 403, pero quien entra por URL debe ver por qué, no una pantalla en error.
 */
export function SoloAdmin({ children }: { children: ReactNode }) {
  const usuario = useUsuarioActual()
  if (usuario.isPending) return <Cargando />
  if (!esAdmin(usuario.data)) {
    return (
      <EstadoVacio
        titulo="Solo para administradores"
        descripcion="Esta pantalla la gestiona un administrador. Si necesitas cambiar algo aquí, pídeselo."
      />
    )
  }
  return <>{children}</>
}
